export default "__VITE_ASSET__HA9AIhUr__"